"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _MessageTemplateModal = _interopRequireDefault(require("./components/MessageTemplateModal.vue"));
var _messageTemplate = require("@/api/messageTemplate.api");
var _messageTemplate2 = require("@/types/messageTemplate");
var Page = /*#__PURE__*/function (_Vue) {
  function Page() {
    var _this;
    (0, _classCallCheck2.default)(this, Page);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, Page, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "ordersExport", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "MessageTemplateTypeTrans", _messageTemplate2.MessageTemplateTypeTrans);
    (0, _defineProperty2.default)(_this, "MessageTemplateTypeDescriptionTrans", _messageTemplate2.MessageTemplateTypeDescriptionTrans);
    (0, _defineProperty2.default)(_this, "row", void 0);
    return _this;
  }
  (0, _inherits2.default)(Page, _Vue);
  return (0, _createClass2.default)(Page, [{
    key: "mounted",
    value: function mounted() {
      this.fetchList();
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.modal.handleUpdate(row);
    }
  }, {
    key: "fetchList",
    value: function () {
      var _fetchList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loading = true;
              _context.next = 4;
              return _messageTemplate.messageTemplateApi.findAll();
            case 4:
              res = _context.sent;
              this.data = res.data.messageTemplates;
              this.total = res.data.total;
            case 7:
              _context.prev = 7;
              this.loading = false;
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 7, 10]]);
      }));
      function fetchList() {
        return _fetchList.apply(this, arguments);
      }
      return fetchList;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
Page = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    MessageTemplateModal: _MessageTemplateModal.default
  }
})], Page);
var _default = exports.default = Page;